// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { authAPI } from '../../services/api';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../../styles/Register.css';

// const COUNTRY_CODES = [
//   { code: '+91', country: 'India',     digits: 10, pattern: /^[6-9]\d{9}$/ },
//   { code: '+1',  country: 'US/Canada', digits: 10, pattern: /^\d{10}$/ },
//   { code: '+44', country: 'UK',        digits: 10, pattern: /^\d{10}$/ },
//   { code: '+61', country: 'Australia', digits: 9,  pattern: /^\d{9}$/  },
//   { code: '+86', country: 'China',     digits: 11, pattern: /^\d{11}$/ },
//   { code: '+33', country: 'France',    digits: 9,  pattern: /^\d{9}$/  },
//   { code: '+49', country: 'Germany',   digits: 10, pattern: /^\d{10}$/ },
//   { code: '+39', country: 'Italy',     digits: 10, pattern: /^\d{10}$/ },
//   { code: '+55', country: 'Brazil',    digits: 11, pattern: /^\d{11}$/ },
//   { code: '+971',country: 'UAE',       digits: 9,  pattern: /^\d{9}$/  },
//   { code: '+65', country: 'Singapore', digits: 8,  pattern: /^\d{8}$/  },
//   { code: '+81', country: 'Japan',     digits: 10, pattern: /^\d{10}$/ },
// ];

// const ORG_TYPES = [
//   { value: '',                label: 'Select organization type' },
//   { value: 'FREELANCER',      label: 'Freelance Recruiter' },
//   { value: 'STAFFING_AGENCY', label: 'Staffing Agency' },
//   { value: 'CORPORATE',       label: 'Corporate' },
// ];

// const BLOCKED_DOMAINS = new Set([
//   'gmail.com','yahoo.com','hotmail.com','outlook.com','aol.com','icloud.com',
//   'yopmail.com','yopmail.fr','yopmail.net','mail.com','email.com',
//   'guerrillamail.com','disposable.com','tempmail.com','fakeinbox.com',
//   'throwaway.com','trashmail.com','10minutemail.com','mailinator.com',
//   'maildrop.cc','dispostable.com','spamgourmet.com','sharklasers.com',
// ]);

// const ALLOWED_CORPORATE = ['atscircle.com', 'flyhii.in'];

// function Register() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     firstName: '', lastName: '', email: '', phone: '',
//     password: '', confirmPassword: '', orgType: '', businessName: '',
//   });
//   const [errors, setErrors]             = useState({});
//   const [termsChecked, setTermsChecked] = useState(false);
//   const [countryCode, setCountryCode]   = useState('+91');
//   const [loading, setLoading]           = useState(false);

//   const selectedCountry = COUNTRY_CODES.find(c => c.code === countryCode) || COUNTRY_CODES[0];
//   const isFreelancer = formData.orgType === 'FREELANCER';
//   const isCorporate  = formData.orgType === 'CORPORATE';

//   /* ── Auto-fill business name for freelancers ───────────────────────── */
//   useEffect(() => {
//     if (isFreelancer && formData.firstName && !formData.businessName) {
//       setFormData(p => ({ ...p, businessName: `${p.firstName} Org` }));
//     }
//     if (!isFreelancer && formData.businessName.endsWith(' Org')) {
//       setFormData(p => ({ ...p, businessName: '' }));
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [formData.orgType, formData.firstName]);

//   /* ── Email validation ──────────────────────────────────────────────── */
//   const validateEmail = (email) => {
//   if (!email) return 'Email is required';
//   if (!/^\S+@\S+\.\S+$/.test(email)) return 'Enter a valid email address';

//   const domain = email.split('@')[1]?.toLowerCase();
//   if (!domain) return 'Enter a valid email address';

//   // ❌ Block personal emails ONLY for non-freelancers
//   if (!isFreelancer && BLOCKED_DOMAINS.has(domain))
//     return 'Personal or disposable email domains are not allowed';

//   if (!isFreelancer && (domain.includes('temp') || domain.includes('fake') || domain.includes('trash')))
//     return 'Disposable email addresses are not allowed';

//   // Corporate domain restriction
//   if (isCorporate) {
//     const ok = ALLOWED_CORPORATE.some(d => domain === d || domain.endsWith('.' + d));
//     if (!ok) return 'Corporate accounts require a work email (e.g. name@atscircle.com)';
//   }

//   return '';
// };

//   /* ── Phone validation ──────────────────────────────────────────────── */
//   const validatePhone = (phone) => {
//     if (!phone) return 'Contact number is required';
//     if (!selectedCountry.pattern.test(phone)) {
//       if (countryCode === '+91') return 'Indian numbers must be 10 digits starting with 6–9';
//       return `Phone must be ${selectedCountry.digits} digits for ${selectedCountry.country}`;
//     }
//     return '';
//   };

//   /* ── Full form validation ──────────────────────────────────────────── */
//   const validateForm = () => {
//     const e = {};

//     if (!formData.firstName.trim())                    e.firstName = 'First Name is required';
//     else if (!/^[a-zA-Z]+$/.test(formData.firstName))  e.firstName = 'First Name should contain only alphabets';

//     if (!formData.lastName.trim())                     e.lastName = 'Last Name is required';
//     else if (!/^[a-zA-Z]+$/.test(formData.lastName))   e.lastName = 'Last Name should contain only alphabets';

//     const emailErr = validateEmail(formData.email);
//     if (emailErr) e.email = emailErr;

//     const phoneErr = validatePhone(formData.phone);
//     if (phoneErr) e.phone = phoneErr;

//     if (!formData.password)                e.password = 'Password is required';
//     else if (formData.password.length < 8) e.password = 'Password must be at least 8 characters long';

//     if (formData.password !== formData.confirmPassword)
//       e.confirmPassword = 'Passwords do not match';

//     if (!formData.orgType) e.orgType = 'Please select an organization type';

//     if (!isFreelancer && !formData.businessName.trim())
//       e.businessName = 'Business Name is required';

//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   /* ── handleChange ──────────────────────────────────────────────────── */
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'firstName' || name === 'lastName') {
//       if (!/^[a-zA-Z]*$/.test(value)) return;
//     }
//     if (name === 'phone') {
//       if (!/^\d*$/.test(value)) return;
//       if (value.length > selectedCountry.digits) return;
//     }
//     if (name === 'orgType') {
//       const updated = { ...formData, [name]: value };
//       if (value !== 'FREELANCER') updated.businessName = '';
//       setFormData(updated);
//       return;
//     }

//     setFormData(p => ({ ...p, [name]: value }));
//   };

//   /* ── Submit ────────────────────────────────────────────────────────── */
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     if (!termsChecked) { toast.warning('Please agree to the Terms & Conditions'); return; }

//     setLoading(true);
//     try {
//       const payload = {
//         firstName:        formData.firstName,
//         lastName:         formData.lastName,
//         password:         formData.password,
//         contactNumber:    formData.phone,
//         countryCode,
//         email:            formData.email,
//         organizationType: formData.orgType,
//         organizationName: formData.businessName || `${formData.firstName} Org`,
//         role: 'ADMIN',
//       };
//       const response = await authAPI.register(payload);
//       if (response.data) {
//         const { id, email, role } = response.data;
//         localStorage.setItem('userId', id);
//         localStorage.setItem('userEmail', email);
//         localStorage.setItem('userRole', role);
//         toast.success('Account created successfully! 🎉');
//         setTimeout(() => navigate('/'), 2000);
//       }
//     } catch (err) {
//       const msg = err.response?.data
//         ? (typeof err.response.data === 'string'
//             ? err.response.data
//             : err.response.data.message || err.response.data.error || 'Registration failed')
//         : 'Registration failed. Please try again.';
//       toast.error(msg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleNameKeyPress  = (e) => { if (!/^[a-zA-Z]$/.test(e.key)) e.preventDefault(); };
//   const handlePhoneKeyPress = (e) => { if (!/\d/.test(e.key)) e.preventDefault(); };

//   return (
//     <div className="app">
//       <ToastContainer
//         position="top-right" autoClose={3000} hideProgressBar={false}
//         newestOnTop={false} closeOnClick rtl={false}
//         pauseOnFocusLoss draggable pauseOnHover theme="light"
//       />

//       <div className="container">

//         {/* ── LEFT SECTION ──────────────────────────────────────────── */}
//         <div className="left-section">
//           <div className="logo-container">
//             <div className="circle-logo">
//               <span className="ats-logo">ATS</span>
//             </div>
//             <span className="circle-text">CIRCLE</span>
//           </div>

//           <h1>Streamline Your Recruitment Process</h1>
//           <p>
//             ATS Circle is the all-in-one HRTech solution designed for recruitment agencies,
//             freelance recruiters, and startups. Simplify your workflow and boost productivity.
//           </p>

//           <ul className="features-list">
//             <li><span className="checkmark">✓</span> Track candidates efficiently</li>
//             <li><span className="checkmark">✓</span> Manage leads and clients</li>
//             <li><span className="checkmark">✓</span> Create and send invoices</li>
//             {!isFreelancer && (
//               <li><span className="checkmark">✓</span> User management</li>
//             )}
//             <li><span className="checkmark">✓</span> Access everything in one dashboard</li>
//             <li><span className="checkmark">✓</span> All-in-one integrated solution</li>
//             <li><span className="checkmark">✓</span> User-friendly interface</li>
//             <li><span className="checkmark">✓</span> Affordable pricing plans</li>
//           </ul>
//         </div>

//         {/* ── RIGHT SECTION ─────────────────────────────────────────── */}
//         <div className="right-section">
//           <div className="form-container">
//             <div className="get-started-section">
//               <h3>Get Started Today</h3>
//               <p className="join-text">Join thousands of recruiters using ATS Circle</p>
//             </div>
//           </div>

//           <form className="signup-form" onSubmit={handleSubmit} noValidate>

//             {/* Name */}
//             <div className="form-row">
//               <div className="form-group">
//                 <label>First Name *</label>
//                 <input
//                   type="text" name="firstName" value={formData.firstName}
//                   placeholder="Enter your first name (letters only)"
//                   onChange={handleChange} onKeyPress={handleNameKeyPress}
//                   className={errors.firstName ? 'error' : ''}
//                 />
//                 {errors.firstName && <span className="error-text">{errors.firstName}</span>}
//               </div>
//               <div className="form-group">
//                 <label>Last Name *</label>
//                 <input
//                   type="text" name="lastName" value={formData.lastName}
//                   placeholder="Enter your last name (letters only)"
//                   onChange={handleChange} onKeyPress={handleNameKeyPress}
//                   className={errors.lastName ? 'error' : ''}
//                 />
//                 {errors.lastName && <span className="error-text">{errors.lastName}</span>}
//               </div>
//             </div>

//             {/* Email & Phone */}
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Business Email *</label>
//                 <input
//                   type="email" name="email" value={formData.email}
//                   placeholder={
//                     isCorporate
//                       ? 'Enter corporate email (e.g. name@atscircle.com)'
//                       : 'Enter business email (no personal/disposable emails)'
//                   }
//                   onChange={handleChange}
//                   className={errors.email ? 'error' : ''}
//                 />
//                 {errors.email && <span className="error-text">{errors.email}</span>}
//                 {isCorporate && !errors.email && (
//                   <span className="error-text" style={{ color: '#666' }}>
//                     Only @atscircle.com or @flyhii.in domains accepted
//                   </span>
//                 )}
//               </div>

//               <div className="form-group">
//                 <label>Contact Number *</label>
//                 <div className="phone-input-container">
//                   <select
//                     className="country-code"
//                     value={countryCode}
//                     onChange={(e) => {
//                       setCountryCode(e.target.value);
//                       setFormData(p => ({ ...p, phone: '' }));
//                     }}
//                   >
//                     {COUNTRY_CODES.map(c => (
//                       <option key={`${c.code}-${c.country}`} value={c.code}>
//                         {c.code} ({c.country})
//                       </option>
//                     ))}
//                   </select>
//                   <input
//                     type="tel" name="phone" value={formData.phone}
//                     placeholder={
//                       countryCode === '+91'
//                         ? '10 digits, starts with 6–9'
//                         : `${selectedCountry.digits}-digit number`
//                     }
//                     onChange={handleChange} onKeyPress={handlePhoneKeyPress}
//                     maxLength={selectedCountry.digits}
//                     className={`phone-input ${errors.phone ? 'error' : ''}`}
//                   />
//                 </div>
//                 {errors.phone && <span className="error-text">{errors.phone}</span>}
//                 {countryCode === '+91' && !errors.phone && formData.phone && (
//                   <span className="error-text" style={{ color: '#666' }}>
//                     Indian mobile numbers must begin with 6, 7, 8 or 9
//                   </span>
//                 )}
//               </div>
//             </div>

//             {/* Password */}
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Password *</label>
//                 <input
//                   type="password" name="password" value={formData.password}
//                   placeholder="Create a password (min. 8 characters)"
//                   onChange={handleChange}
//                   className={errors.password ? 'error' : ''}
//                 />
//                 {errors.password && <span className="error-text">{errors.password}</span>}
//               </div>
//               <div className="form-group">
//                 <label>Confirm Password *</label>
//                 <input
//                   type="password" name="confirmPassword" value={formData.confirmPassword}
//                   placeholder="Confirm your password"
//                   onChange={handleChange}
//                   className={errors.confirmPassword ? 'error' : ''}
//                 />
//                 {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
//                 {formData.confirmPassword && !errors.confirmPassword &&
//                   formData.password === formData.confirmPassword && (
//                   <span className="error-text" style={{ color: '#16a34a' }}>✓ Passwords match</span>
//                 )}
//               </div>
//             </div>

//             {/* Org Type & Business Name */}
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Organization Type *</label>
//                 <div className="custom-select-container">
//                   <select
//                     className={`organization-select ${errors.orgType ? 'error' : ''}`}
//                     name="orgType" value={formData.orgType} onChange={handleChange}
//                   >
//                     {ORG_TYPES.map(t => (
//                       <option key={t.value} value={t.value}>{t.label}</option>
//                     ))}
//                   </select>
//                   <span className="custom-arrow"></span>
//                 </div>
//                 {errors.orgType && <span className="error-text">{errors.orgType}</span>}
//               </div>

//               <div className="form-group">
//                 <label>
//                   Business Name {!isFreelancer && '*'}
//                 </label>
//                 <input
//                   type="text" name="businessName" value={formData.businessName}
//                   placeholder={
//                     isFreelancer
//                       ? `Optional – defaults to "${formData.firstName || 'Your'} Org"`
//                       : 'Enter your business name'
//                   }
//                   onChange={handleChange}
//                   className={errors.businessName ? 'error' : ''}
//                 />
//                 {errors.businessName && <span className="error-text">{errors.businessName}</span>}
//                 {isFreelancer && !errors.businessName && (
//                   <span className="error-text" style={{ color: '#666' }}>
//                     Defaults to "{formData.firstName || 'Your'} Org" if left blank
//                   </span>
//                 )}
//               </div>
//             </div>

//             {/* Terms */}
//             <div className="terms-agreement">
//               <input
//                 type="checkbox" id="terms" checked={termsChecked}
//                 onChange={(e) => setTermsChecked(e.target.checked)}
//               />
//               <label htmlFor="terms">
//                 <strong>I agree to the</strong>{' '}
//                 <a href="/terms" target="_blank" rel="noopener noreferrer" className="terms-link">
//                   <strong>Terms &amp; Conditions</strong>
//                 </a>
//               </label>
//             </div>

//             {/* Submit */}
//             <button
//               type="submit"
//               className="create-account-btn"
//               disabled={!termsChecked || loading}
//             >
//               <strong>{loading ? 'Creating account...' : 'Create Account'}</strong>
//             </button>

//             <p className="login-link">
//               Already have an account? <Link to="/">Log in</Link>
//             </p>

//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Register;

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/Register.css';
import { isPasswordValid, PASSWORD_REQUIREMENT_TEXT } from '../../utils/passwordPolicy';
import { normalizeEmail, isValidEmailFormat } from '../../utils/emailUtils';

// CR-130: one reusable Unicode-aware name definition — letters (any script),
// spaces, apostrophe, hyphen, period. Backend mirrors this exact rule. A trimmed
// name must also contain at least one letter — punctuation-only values like
// "---" or "'-." are not valid names even though every individual character is
// in the allowed set.
const NAME_PATTERN = /^[\p{L} .'-]+$/u;
const NAME_HAS_LETTER = /\p{L}/u;
const isValidName = (name) => NAME_PATTERN.test(name) && NAME_HAS_LETTER.test(name);

const COUNTRY_CODES = [
  { code: '+91', country: 'India', digits: 10, pattern: /^[6-9]\d{9}$/ },
  { code: '+1', country: 'US/Canada', digits: 10, pattern: /^\d{10}$/ },
  { code: '+44', country: 'UK', digits: 10, pattern: /^\d{10}$/ },
  { code: '+61', country: 'Australia', digits: 9, pattern: /^\d{9}$/ },
  { code: '+86', country: 'China', digits: 11, pattern: /^\d{11}$/ },
  { code: '+33', country: 'France', digits: 9, pattern: /^\d{9}$/ },
  { code: '+49', country: 'Germany', digits: 10, pattern: /^\d{10}$/ },
  { code: '+39', country: 'Italy', digits: 10, pattern: /^\d{10}$/ },
  { code: '+55', country: 'Brazil', digits: 11, pattern: /^\d{11}$/ },
  { code: '+971', country: 'UAE', digits: 9, pattern: /^\d{9}$/ },
  { code: '+65', country: 'Singapore', digits: 8, pattern: /^\d{8}$/ },
  { code: '+81', country: 'Japan', digits: 10, pattern: /^\d{10}$/ },
];

const ORG_TYPES = [
  { value: '', label: 'Select organisation type' },
  { value: 'FREELANCER', label: 'Freelance Recruiter' },
  { value: 'STAFFING_AGENCY', label: 'Staffing Agency' },
  { value: 'CORPORATE', label: 'Corporate' },
];

function Register() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', phone: '',
    password: '', confirmPassword: '', orgType: '', businessName: '',
  });
  const [errors, setErrors] = useState({});
  const [termsChecked, setTermsChecked] = useState(false);
  const [countryCode, setCountryCode] = useState('+91');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // CR-135: duplicate-email inline recovery — distinct from ordinary format
  // errors so it can render the "logging in instead" link instead of plain text.
  const [duplicateEmailError, setDuplicateEmailError] = useState(false);

  const selectedCountry = COUNTRY_CODES.find(c => c.code === countryCode) || COUNTRY_CODES[0];
  const isFreelancer = formData.orgType === 'FREELANCER';
  const isCorporate = formData.orgType === 'CORPORATE';

  /* ── Auto-fill business name for freelancers ───────────────────────── */
  useEffect(() => {
    if (isFreelancer) {
      setFormData(p => ({ ...p, businessName: p.firstName ? `${p.firstName} Consulting` : '' }));
    }
    if (!isFreelancer && formData.businessName.endsWith(' Consulting')) {
      setFormData(p => ({ ...p, businessName: '' }));
    }
  }, [formData.orgType, formData.firstName]); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── Email validation ──────────────────────────────────────────────── */
  // CR-129: one authoritative format rule, mirroring the backend exactly. No
  // domain blocklist/allowlist and no Gmail/Outlook special case — personal
  // email is valid for every organisation type per ratified Signup §6.
  // CR-128: validated against the NORMALIZED value (trim → lowercase → validate),
  // matching the ratified order and the backend's own normalize-before-validate
  // sequence. The visible field is never rewritten while typing — only the
  // validation/submission boundary sees the normalized value.
  const validateEmail = (email) => {
    const normalized = normalizeEmail(email);
    if (!normalized) return 'Email is required';
    if (!isValidEmailFormat(normalized)) return 'Enter a valid email address';
    return '';
  };

  /* ── Phone validation ──────────────────────────────────────────────── */
  // CR-131: phone is optional. Validate only when the user actually supplied one.
  const validatePhone = (phone) => {
    if (!phone) return '';
    if (!selectedCountry.pattern.test(phone)) {
      return 'Enter a valid phone number for the selected country';
    }
    return '';
  };

  /* ── Full form validation ──────────────────────────────────────────── */
  const validateForm = () => {
    const e = {};

    if (!formData.firstName.trim()) e.firstName = 'First Name is required';
    else if (!isValidName(formData.firstName.trim())) e.firstName = 'Enter a valid first name';

    if (!formData.lastName.trim()) e.lastName = 'Last Name is required';
    else if (!isValidName(formData.lastName.trim())) e.lastName = 'Enter a valid last name';

    const emailErr = validateEmail(formData.email);
    if (emailErr) e.email = emailErr;

    const phoneErr = validatePhone(formData.phone);
    if (phoneErr) e.phone = phoneErr;

    if (!formData.password) e.password = 'Password is required';
    else if (!isPasswordValid(formData.password)) e.password = PASSWORD_REQUIREMENT_TEXT;

    if (formData.password !== formData.confirmPassword)
      e.confirmPassword = 'Passwords do not match';

    if (!formData.orgType) e.orgType = 'Please select an organisation type';

    if (!isFreelancer && !formData.businessName.trim())
      e.businessName = 'Business Name is required';

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ── handleChange ──────────────────────────────────────────────────── */
  const handleChange = (e) => {
    const { name, value } = e.target;

    // CR-130: no per-keystroke character filtering on names — it was the
    // original source of the ASCII-only bug. Submit-time validateForm (above)
    // is the single, correct enforcement point for the Unicode name rule.
    if (name === 'phone') {
      if (!/^\d*$/.test(value)) return;
      if (value.length > selectedCountry.digits) return;
    }
    if (name === 'orgType') {
      const updated = { ...formData, [name]: value };
      if (value !== 'FREELANCER') updated.businessName = '';
      setFormData(updated);
      return;
    }

    // CR-135: clear the duplicate-email inline error as soon as the user edits it.
    if (name === 'email' && duplicateEmailError) {
      setDuplicateEmailError(false);
      setErrors(prev => ({ ...prev, email: undefined }));
    }

    setFormData(p => ({ ...p, [name]: value }));
  };

  /* ── Submit ────────────────────────────────────────────────────────── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!termsChecked) { toast.warning('Please agree to the Terms & Conditions'); return; }

    setLoading(true);
    try {
      const normalizedEmail = normalizeEmail(formData.email);
      const payload = {
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        password: formData.password,
        contactNumber: formData.phone,
        countryCode,
        email: normalizedEmail,
        organizationType: formData.orgType,
        // CR-133: Freelancer Business Name is backend-authoritative — the field
        // is omitted here entirely rather than submitted as if it were data the
        // frontend owns. Agency/Corporate send their own mandatory manual value.
        ...(isFreelancer ? {} : { organizationName: formData.businessName }),
        // CR-141: role removed — backend independently and exclusively assigns it.
      };
      const response = await authAPI.register(payload);
      if (response.data) {
        const { verificationEmailSent } = response.data;
        // Security-reconciliation correction: the account is PENDING/
        // unverified at this point — no identity fields (userId/userEmail/
        // userRole) are written to localStorage pre-verification, since that
        // storage is treated elsewhere as "logged in" state. The only thing
        // persisted here is a transient UX hint, in sessionStorage, never
        // authoritative identity state and never placed in the URL.
        try { sessionStorage.setItem('pendingVerificationEmail', normalizedEmail); } catch { /* ignore */ }
        if (verificationEmailSent === false) {
          toast.error("We couldn't send your verification code. Please try again.");
        }
        navigate('/verify-email');
      }
    } catch (err) {
      if (err.response?.status === 409) {
        // CR-135: inline recovery only — no simultaneous toast for this case.
        const data = err.response.data;
        const message = (data && typeof data === 'object' && data.message)
          ? data.message
          : 'An account with this email already exists. Try logging in instead.';
        setDuplicateEmailError(true);
        setErrors(prev => ({ ...prev, email: message }));
      } else {
        const msg = err.response?.data
          ? (typeof err.response.data === 'string'
            ? err.response.data
            : err.response.data.message || err.response.data.error || 'Registration failed')
          : 'Registration failed. Please try again.';
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneKeyPress = (e) => { if (!/\d/.test(e.key)) e.preventDefault(); };

  return (
    <>
      <ToastContainer
        position="top-right" autoClose={3000} hideProgressBar={false}
        newestOnTop={false} closeOnClick rtl={false}
        pauseOnFocusLoss draggable pauseOnHover theme="light"
      />

      <div className="register-container">

        {/* ── LEFT SECTION ──────────────────────────────────────────── */}
        <div className="left-section">
          <div className="branding-header">
            <p className="branding-text">THE ONLY TOOL YOUR RECRUITMENT BUSINESS NEEDS</p>
          </div>

          <h1 className="hero-title">
            Your next placement<br />starts here.
          </h1>

          <p className="hero-subtitle">
            Most tools make you pay more as you grow. ClustrOps gives you CRM, ATS, and invoicing — all in one place, at one flat price.
          </p>

          <div className="features-container">
            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
              </div>
              <div className="feature-text">
                <strong>Client called. Log it, task it, close it.</strong>
                <p>CRM keeps every relationship moving forward.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
              </div>
              <div className="feature-text">
                <strong>Candidate placed. Invoice drafted. You send it.</strong>
                <p>Mark as hired. Invoice drafts itself. You review and send.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>
              </div>
              <div className="feature-text">
                <strong>Profile shared. Client responded. No login required.</strong>
                <p>Expiry link. One click. Feedback syncs instantly.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" /></svg>
              </div>
              <div className="feature-text">
                <strong>Dashboard open. You know exactly what to do.</strong>
                <p>Smart action cards. No guesswork. Just work.</p>
              </div>
            </div>
          </div>

          <div className="badges-container">
            <span className="badge"><span className="badge-dot"></span>Built for India. GST-native.</span>
            <span className="badge"><span className="badge-dot"></span>Flat pricing. No upgrade walls.</span>
            <span className="badge">14-day free trial. No card.</span>
          </div>
        </div>

        {/* ── RIGHT SECTION ─────────────────────────────────────────── */}
        <div className="right-section">
          <div className="right-section-content">
            <div className="logo-section">
              <img
                src="/clustrops-logo.png"
                alt="ClustrOps"
                style={{ height: 54, objectFit: 'contain' }}
              />

            </div>

            <div className="auth-top-bar">
              <button type="button" className="toggle-btn active">Start Free Trial</button>
              <Link to="/login" className="toggle-btn inactive">Log In</Link>
            </div>

            <div className="form-header">
              <h2 className="form-title">Start your free trial</h2>
              <p className="form-subtitle">No credit card. No setup fee. Import your data and go live in minutes.</p>
            </div>

            <form className="signup-form" onSubmit={handleSubmit} noValidate>
              {/* Row 1: First Name & Last Name */}
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  <input
                    type="text" name="firstName" value={formData.firstName}
                    placeholder="Priya"
                    onChange={handleChange}
                    className={errors.firstName ? 'error' : ''}
                  />
                  {errors.firstName && <span className="error-text">{errors.firstName}</span>}
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text" name="lastName" value={formData.lastName}
                    placeholder="Sharma"
                    onChange={handleChange}
                    className={errors.lastName ? 'error' : ''}
                  />
                  {errors.lastName && <span className="error-text">{errors.lastName}</span>}
                </div>
              </div>

              {/* Row 2: Organisation Type & Business Name */}
              <div className="form-row">
                <div className="form-group">
                  <label>Organisation Type <span className="required-asterisk">*</span></label>
                  <div className="custom-select-container">
                    <select
                      className={`organization-select ${errors.orgType ? 'error' : ''}`}
                      name="orgType" value={formData.orgType} onChange={handleChange}
                    >
                      <option value="" disabled>Select type...</option>
                      {ORG_TYPES.filter(t => t.value !== '').map(t => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </select>
                    <span className="custom-arrow"></span>
                  </div>
                  {errors.orgType && <span className="error-text">{errors.orgType}</span>}
                </div>
                <div className="form-group">
                  <label>Business Name</label>
                  <input
                    type="text" name="businessName" value={formData.businessName}
                    placeholder={isFreelancer ? '' : 'Your business name'}
                    onChange={handleChange}
                    disabled={isFreelancer}
                    className={errors.businessName ? 'error' : ''}
                  />
                  {errors.businessName && <span className="error-text">{errors.businessName}</span>}
                </div>
              </div>

              {/* Row 3: Email & Phone */}
              <div className="form-row">
                <div className="form-group">
                  <label>Work Email</label>
                  <input
                    type="email" name="email" value={formData.email}
                    placeholder="you@company.com"
                    onChange={handleChange}
                    className={errors.email ? 'error' : ''}
                  />
                  {duplicateEmailError ? (
                    <span className="error-text">
                      An account with this email already exists. Try{' '}
                      <Link to="/login">logging in instead</Link>.
                    </span>
                  ) : (
                    <>
                      {errors.email && <span className="error-text">{errors.email}</span>}
                      {!errors.email && (formData.orgType === 'STAFFING_AGENCY' || isCorporate) && (
                        <span className="error-text" style={{ color: '#666' }}>Work email recommended.</span>
                      )}
                    </>
                  )}
                </div>
                <div style={{
                  flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column',
                }}>
                  <label style={{ fontSize: '0.72rem', fontWeight: '600', color: '#475569', marginBottom: '4px', textAlign: 'left' }}>Phone Number</label>
                  <div style={{
                    display: 'flex',
                    border: `1.5px solid ${errors.phone ? '#ef4444' : '#e2e8f0'}`,
                    borderRadius: '8px',
                    overflow: 'hidden',
                    height: '38px',
                    backgroundColor: '#fcfcfc',
                  }}>
                    <select
                      style={{
                        background: '#f8fafc',
                        border: 'none',
                        borderRight: '1.5px solid #e2e8f0',
                        padding: '0 22px 0 10px',
                        fontSize: '0.78rem',
                        fontWeight: '600',
                        color: '#475569',
                        cursor: 'pointer',
                        height: '100%',
                        outline: 'none',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E\")",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 6px center',
                        backgroundSize: '8px 5px',
                      }}
                      value={countryCode}
                      onChange={(e) => {
                        setCountryCode(e.target.value);
                        setFormData(p => ({ ...p, phone: '' }));
                      }}
                    >
                      {COUNTRY_CODES.map(c => (
                        <option key={`${c.code}-${c.country}`} value={c.code}>{c.code}</option>
                      ))}
                    </select>
                    <input
                      type="tel" name="phone" value={formData.phone}
                      placeholder="+91 98765 43210"
                      onChange={handleChange} onKeyPress={handlePhoneKeyPress}
                      maxLength={selectedCountry.digits}
                      style={{
                        border: 'none',
                        flex: 1,
                        padding: '0 12px',
                        fontSize: '0.8rem',
                        backgroundColor: 'transparent',
                        outline: 'none',
                      }}
                    />
                  </div>
                  {errors.phone && <span className="error-text">{errors.phone}</span>}
                </div>
              </div>

              {/* Row 4: Password & Confirm Password */}
              <div className="form-row">
                <div className="form-group password-field">
                  <label>Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? 'text' : 'password'} name="password" value={formData.password}
                      placeholder="Create password"
                      onChange={handleChange}
                      className={errors.password ? 'error' : ''}
                    />
                    <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                      )}
                    </span>
                  </div>
                  {errors.password && <span className="error-text">{errors.password}</span>}
                </div>
                <div className="form-group password-field">
                  <label>Confirm Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showConfirmPassword ? 'text' : 'password'} name="confirmPassword" value={formData.confirmPassword}
                      placeholder="Confirm password"
                      onChange={handleChange}
                      className={errors.confirmPassword ? 'error' : ''}
                    />
                    <span className="password-toggle-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      {showConfirmPassword ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                      )}
                    </span>
                  </div>
                  {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
                </div>
              </div>

              <div className="data-info">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                <span>Your data is never sold. Cancel anytime.</span>
              </div>

              <div className="terms-checkbox-container">
                <input
                  type="checkbox"
                  id="termsChecked"
                  checked={termsChecked}
                  onChange={(e) => setTermsChecked(e.target.checked)}
                />
                <label htmlFor="termsChecked">
                  I agree to the <Link to="/terms" target="_blank">Terms of Service</Link> and <Link to="/privacy" target="_blank">Privacy Policy</Link>
                </label>
              </div>

              <button type="submit" className="create-account-btn" disabled={loading || !termsChecked}>
                {loading ? 'Creating account...' : 'Start My 14 Days. No Card.'}
              </button>

              <div className="already-have-account">
                Already have an account? <Link to="/login">Log in</Link>
              </div>

              <div className="back-to-link">
                <Link to="/">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
                  Back to clustrops.com
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;